import type { FetchResult } from "./opsPaperworkClientBase";
import { opsFetch, q } from "./opsPaperworkClientBase";

export type OpsQuickbooksOAuthStatus = {
  connected: boolean;
  realm_id: string | null;
  expires_at: string | null;
  connected_at: string | null;
};

export type OpsQuickbooksConfig = {
  enabled: boolean;
  realm_id: string | null;
  conflict_policy: string;
  customer_match_mode?: "default_ref" | "match_or_create";
  triggers: { customer_order_submitted: boolean };
  invoice_defaults: { service_item_id: string; customer_ref: string };
};

export type OpsQuickbooksLedgerRow = {
  id: string;
  deal_id: string | null;
  qb_entity_type: string;
  qb_entity_id: string | null;
  trigger_key: string;
  sync_status: string;
  created_at: string;
};

export async function getOpsQuickbooksConfig(): Promise<
  FetchResult<{
    ok: true;
    config: OpsQuickbooksConfig;
    credentials_present: boolean;
    oauth_status: OpsQuickbooksOAuthStatus;
    oauth_connect_available: boolean;
  }>
> {
  return opsFetch(q("quickbooks-config"));
}

export async function getOpsQuickbooksOAuthStart(): Promise<
  FetchResult<{ ok: true; authorize_url: string; redirect_uri: string }>
> {
  return opsFetch(q("quickbooks-oauth-start"));
}

export async function postOpsQuickbooksOAuthDisconnect(): Promise<
  FetchResult<{
    ok: true;
    config: OpsQuickbooksConfig;
    credentials_present: boolean;
    oauth_status: OpsQuickbooksOAuthStatus;
    oauth_connect_available: boolean;
  }>
> {
  return opsFetch(q("quickbooks-oauth-disconnect"), { method: "POST" });
}

export async function patchOpsQuickbooksConfig(
  config: OpsQuickbooksConfig
): Promise<FetchResult<{ ok: true; config: OpsQuickbooksConfig; credentials_present: boolean }>> {
  return opsFetch(q("quickbooks-config"), {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ quickbooks_retail_config: config }),
  });
}

export async function getOpsQuickbooksLedger(): Promise<
  FetchResult<{ ok: true; ledger: OpsQuickbooksLedgerRow[] }>
> {
  return opsFetch(q("quickbooks-ledger"));
}

export async function postOpsQuickbooksPushDeal(dealId: string): Promise<FetchResult<Record<string, unknown>>> {
  return opsFetch(q("quickbooks-push-deal"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ deal_id: dealId }),
  });
}
